import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/wistcorp/links'
  },
  {
    path: '/wistcorp/:id',
    name: 'Wist Colaborador',
    component:()=>import('../views/ColabView.vue')
  },
  {
    path: '/wistcorp/links',
    name:'Wist Links',
    component:()=>import('../views/CompanyLinksView.vue')
  },
  // {
  //   path: '/login',
  //   name:'Login',
  //   component:()=>import('../views/LoginView.vue')
  // },
  // {
  //   path: '/edit/colab/:id',
  //   name:'ColabEdit',
  //   component:()=>import('../views/EditColabData.vue')
  // },
  // {
  //   path: '/edit/company',
  //   name:'CompanyEdit',
  //   component:()=>import('../views/EditCompanyData.vue')
  // },
  // {
  //   path: '/dashboard',
  //   name:'Dashboard',
  //   component:()=>import('../views/DashboardView.vue')
  // },
  // {
  //   path: '/create/colab',
  //   name:'CreateColab',
  //   component:()=>import('../views/CreateColab.vue')
  // },
  {
    path: "/:catchAll(.*)",
    name: 'NotFound',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.name;
  next();
});

export default router
